import API from "./API";
import axios from "axios";

const Social = {

    async getPosts(filter, postId, page, search, tagId, courseId){
        const query = 
            `?filter=${filter}&id=${postId || ''}&page=${page || 1}&search=${search || ''}&tag=${tagId || ''}&course=${courseId || ''}`;
        const url = API.url('/social/posts' + query);
        const r = await axios.get(url);
        return r;
    },

    async getPost(id){
        const url = API.url(`/social/posts/${id}`);
        return await axios.get(url);
    },

    async deletePost(id){
        const url = API.url(`/social/posts/${id}`);
        return await axios.delete(url);
    },

    async deleteComment(id){
        const url = API.url(`/social/comments/${id}`);
        return await axios.delete(url);
    },

    async getPostComments(id){
        const url = API.url(`/social/posts/${id}/comments`);
        return await axios.get(url);
    },

    async getPostReactions(id){
        const url = API.url(`/social/posts/${id}/reactions`);
        return await axios.get(url);
    },

    async postPost(data){
        const url = API.url('/social/posts');
        return await axios.post(url, data);
    },

    async putPost(data){
        const url = API.url('/social/posts/' + data.id);
        return await axios.put(url, data);
    },

    async postComment(data){
        const url = API.url(`/social/posts/${data.post.id}/comments`);
        const r = await axios.post(url, data);
        console.log(r.data);
        return r;
    },

    async postReaction(data){
        const url = API.url(`/social/posts/${data.post.id}/reactions`);
        console.log(data)
        return await axios.post(url, data);
    },

    async deleteReaction(postId){
        const url = API.url(`/social/posts/${postId}/reactions`);
        return await axios.delete(url);
    },

    async getSection(id){
        const url = API.url(`/social/sections/${id}`);
        return await axios.get(url);
    },

    async getCourseTag(courseId){
        const url = API.url(`/social/courses/${courseId}/tag`);
        return await axios.get(url);
    },

    async getMyCategoryTag(){
        const url = API.url(`/social/tags/my-category`);
        return await axios.get(url);
    },

    async postPictures(postId, files){
        const url = API.url(`/social/posts/${postId}/pictures`);
        const data = new FormData();
        files.map((f,i) => data.append(`picture_${i}`, f));
        return await axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    async deletePostPicture(fileName){
        const url = API.url(`/social/posts/pictures/${fileName}`);
        return await axios.delete(url);
    },

    async toggleFavorite(postId){
        const url = API.url(`/social/posts/${postId}/favorite`);
        return await axios.get(url);
    },

    async generateReply(postId){
        const url = API.url(`/chat/posts/${postId}/reply`);
        return await axios.get(url);
    },
}

export default Social;